// extracted by mini-css-extract-plugin
export default {"container":"styles_container__un70H","heading":"styles_heading__S13Tn","description":"styles_description__zMacb"};